<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
  	return{
  		
  	}
  }
};
</script>

<style>
	body,html,#app{width:100%;height:100%;}
  *{margin:0;padding:0;}
  .el-icon-circle-close{
  color: #cacaca !important;
}
.el-table .cell{padding-left:4px !important;padding-right:4px !important;}
.clearfix:before,.clearfix:after{display:block !important;clear:both !important;content:"";visibility:hidden;height:0;}
.clearfix{zoom:1;}
.draweritem100 .el-input,.draweritem100 .el-select,.draweritem100 .el-textarea{width:608px !important;} 
  /*gm滚动条样式gm*/
  ::-webkit-scrollbar{width: 5px;height: 8px;background-color:#fafafa;}
  ::-webkit-scrollbar-track{-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);border-radius: 10px;background-color: #fafafa;}
  ::-webkit-scrollbar-thumb{border-radius: 10px;-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);background-color: #aaa;}
</style>



// WEBPACK FOOTER //
// src/App.vue